/* eslint-disable import/no-cycle */
import { IDealApiModel } from './api/deal.api.model';
import { IPlaceApiV5Model } from './api/place.api.model';
import { PlaceModel } from './place.model';

export class DealModel {
  id: string;
  title: string;
  slug: string;
  description: string;
  additionalInfo: string;
  cost: number;
  isPublished: boolean;
  showInGrantList: boolean;
  expirationDate: string | null;
  image: string;
  keysNum: number;
  keysUsed: number;
  nCouponsPerPerson: number;
  nCouponsPerPersonAtOnce: number;
  unlockables: IDealApiModel['unlockables'];
  isDeleted: boolean;

  verifiedCount: number | null;
  notVerifiedCount: number | null;

  private _places: Array<IPlaceApiV5Model>;

  get places(): Array<PlaceModel> {
    return this._places ? this._places.map(item => new PlaceModel(item)) : [];
  }

  constructor(source?: IDealApiModel) {
    if (source == null) {
      return;
    }

    this.id = source.id;
    this.title = source.title;
    this.slug = source.slug;
    this.description = source.description;
    this.additionalInfo = source.additional_info;
    this.cost = source.cost;
    this.isPublished = source.is_published;
    this.showInGrantList = source.show_in_grant_list;
    this.expirationDate = source.expiration_date;
    this.image = source.image;
    this.keysNum = source.keys_num;
    this.keysUsed = source.keys_used;
    this.nCouponsPerPerson = source.c_coupons_per_person;
    this.nCouponsPerPersonAtOnce = source.c_coupons_per_person_at_once;
    this._places = source.beacons;
    this.unlockables = source.unlockables;
    this.isDeleted = source.isDeleted;

    this.verifiedCount = source.verified_count;
    this.notVerifiedCount = source.not_verified_count;
  }

  static copyObj(source: Pick<DealModel, keyof DealModel>): DealModel {
    return Object.assign(new DealModel(), source);
  }
}
